export default {
    cn: {
        autoUpdateLeverage: {
            accHead: [
                { key: 'group', value: '组别' },
                { key: 'equity_valve', value: '净值数值设定' },
                { key: 'leverage_lte', value: '杠杆倍数(小于或等于)' },
                { key: 'leverage_gt', value: '杠杆倍数(大于)' },
                { key: 'enableDesc', value: '每天执行' },
                { key: 'modify_by', value: '最后修改人' },
            ],
            addGroupTxt: '组别',
            addEquityTxt: '净值数值设定(保留两位小数)',
            addLeveragelteTxt: '杠杆倍数(小于或等于)',
            addLeveragegtTxt: '杠杆倍数(大于)',
            addEnableTxt: '每天执行',
            yesTxt: '是',
            noTxt: '否',

            groupRulesRequired: '请选择组别',
            equityRulesRequired: '请输入净值数值设定',
            equityRulesNumber: '净值数值必须为正整数',
            leverageLteRulesRequired: '请输入杠杆倍数',
            leverageLteRulesNumber: '杠杆倍数必须为正整数',
            leverageGtRulesRequired: '请输入杠杆倍数',
            leverageGtRulesNumber: '杠杆倍数必须为正整数',
            descriptionTxt: `如果今天自动更新交易账号杠杆发生问题需要重新处理，可以将组别为Rerun_Program的那行数据的"每天执行"更新为"是"，
                变更之后的第10分钟生效(例如在上午8点10分20秒更新的，需要在上午8点20分程序才会重新处理)。程序重新处理开始后，"杠杆倍数(大于)"将会变为"2"。
                程序重新处理完之后，"杠杆倍数(大于)"将会变为"1"，"每天执行"将会自动变为"否"。`,

            addBtnTxt: '新增配置项',
            addDialogTitle: '请填写配置信息',
            formSelectDefaultTxt: '请选择',
            formCancelTxt: '取 消',
            formConfirmTxt: '确 定',
            deleteMsgTxt: '确定要删除这个配置吗？',
            notifyTxt: '提示',
            addSuccess: '新增配置成功',
            addFailed: '新增配置失败',
            updateSuccess: '更新配置成功',
            updateFailed: '更新配置失败',
            delSuccess: '移除配置成功',
            delFailed: '移除配置失败',
            lastTableColumnTxt: '操作',
        }
    },
    hk: {
        autoUpdateLeverage: {
            accHead: [
                { key: 'group', value: '組別' },
                { key: 'equity_valve', value: '淨值數值設定' },
                { key: 'leverage_lte', value: '槓桿倍數(小於或等於)' },
                { key: 'leverage_gt', value: '槓桿倍數(大於)' },
                { key: 'enableDesc', value: '每天執行' },
                { key: 'modify_by', value: '最後修改人' },
            ],
            addGroupTxt: '組別',
            addEquityTxt: '淨值數值(保留兩位小數)',
            addLeveragelteTxt: '槓桿倍數(小於或等於)',
            addLeveragegtTxt: '槓桿倍數(大於)',
            addEnableTxt: '每天執行',
            yesTxt: '是',
            noTxt: '否',

            groupRulesRequired: '請選擇組別',
            equityRulesRequired: '請輸入淨值數值設定',
            equityRulesNumber: '淨值數值必須為正整數',
            leverageLteRulesRequired: '請輸入槓桿倍數',
            leverageLteRulesNumber: '槓桿倍數必須為正整數',
            leverageGtRulesRequired: '請輸入槓桿倍數',
            leverageGtRulesNumber: '槓桿倍數必須為正整數',
            descriptionTxt: `如果今天自動更新交易賬號槓桿發生問題需要重新處理，可以將組別為Rerun_Program的那行數據的"每天執行"更新為"是"，
                變更之後的第10分鐘生效(例如在上午8點10分20秒更新的，需要在上午8點20分程序才會重新處理)。程序重新處理開始後，"槓桿倍數(大於)"將會變為"2"。
                程序重新處理完之後，"槓桿倍數(大於)"將會變為"1"，"每天執行"將會自動變為"否"。`,

            addBtnTxt: '新增配置項',
            addDialogTitle: '請填寫配置信息',
            formSelectDefaultTxt: '請選擇',
            formCancelTxt: '取 消',
            formConfirmTxt: '確 定',
            deleteMsgTxt: '確定要刪除這個配置嗎？',
            notifyTxt: '提示',
            addSuccess: '新增配置成功',
            addFailed: '新增配置失敗',
            updateSuccess: '更新配置成功',
            updateFailed: '更新配置失敗',
            delSuccess: '移除配置成功',
            delFailed: '移除配置失敗',
            lastTableColumnTxt: '操作',
        }
    },
    en: {
        autoUpdateLeverage: {
            accHead: [
                { key: 'group', value: 'Group' },
                { key: 'equity_valve', value: 'Equity Value Setting' },
                { key: 'leverage_lte', value: 'Leverage Ratio(Less than or equal to)' },
                { key: 'leverage_gt', value: 'Leverage Ratio(Greater than)' },
                { key: 'enableDesc', value: 'Daily Execution' },
                { key: 'modify_by', value: 'Modify By' },
            ],
            addGroupTxt: 'Group',
            addEquityTxt: 'Equity Value Setting(Two decimal places)',
            addLeveragelteTxt: 'Leverage Ratio(Less than or equal to)',
            addLeveragegtTxt: 'Leverage Ratio(Greater than)',
            addEnableTxt: 'Daily Execution',
            yesTxt: 'Yes',
            noTxt: 'No',

            groupRulesRequired: 'Please select a group',
            equityRulesRequired: 'Please input the equity value setting',
            equityRulesNumber: 'Equity value must be a positive integer',
            leverageLteRulesRequired: 'Please input the Leverage Ratio',
            leverageLteRulesNumber: 'Leverage ratio must be a positive integer',
            leverageGtRulesRequired: 'Please input the Leverage Ratio',
            leverageGtRulesNumber: 'Leverage ratio must be a positive integer',
            descriptionTxt: `If a problem occurs with the automatic update of trading account leverage, and it needs reprocessing, 
                operator can update the "Daily Execution" manually by the row which group called "Rerun_Program". Switch it to "Yes", 
                and activate leverage execution. The process takes effect in 10 minutes, example (at 08:10:20 A.M., the program execute 
                the rerun at 08:20:00 A.M.). When the program is reprocessing, "Leverage (greater than)" will be changed to "2". When the 
                processing is finished, "Leverage (greater than)" will change to "1". The "Daily Execution" will automatically change to "No".`,

            addBtnTxt: 'Add a new configuration',
            addDialogTitle: 'Please fill in the configuration information',
            formSelectDefaultTxt: 'Please select',
            formCancelTxt: 'Cancel',
            formConfirmTxt: 'OK',
            deleteMsgTxt: 'Are you sure you want to delete this configuration?',
            notifyTxt: 'Notify',
            addSuccess: 'Add configuration successfully',
            addFailed: 'Failed to add configuration',
            updateSuccess: 'Update configuration successfully',
            updateFailed: 'Failed to update configuration',
            delSuccess: 'Delete configuration successfully',
            delFailed: 'Failed to delete configuration',
            lastTableColumnTxt: 'Handle',
        }
    }
}


// WEBPACK FOOTER //
// ./src/language/report/autoUpdateLeverage.js